import React from 'react';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationUtils } from 'app/modules/form-builder-lib';

export const useFormStepper = ({ formButtons, defaultValues, values, fields }) => {
  const schema = validationUtils.getFormSchema(Array.isArray(fields) ? fields : fields());
  const methods = useForm({
    ...(defaultValues ? { defaultValues } : {}),
    mode: 'all',
    ...(values ? { values } : {}),
    resolver: yupResolver(schema),
  });

  let formFields;
  if (Array.isArray(fields)) {
    formFields = fields;
  } else {
    formFields = fields(methods.watch);
  }

  const FormButtons = formButtons
    ? formButtons
    : ({ children }) => {
        return <>{children}</>;
      };

  return { methods, fields: formFields, FormButtons };
};
